import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {usePerPage} from 'src/hooks/usePerPage';
import {withSuspense} from 'src/utils/withSuspense';

import {listPagegeneralAssetModelsQuery} from './__generated__/listPagegeneralAssetModelsQuery.graphql';
import GeneralAssetModelsTable from './GeneralAssetModelsTable';

function ListPage() {
  const {perPage} = usePerPage();
  const data = useLazyLoadQuery<listPagegeneralAssetModelsQuery>(
    generalAssetModels,
    {first: perPage * 2},
    {fetchPolicy: 'store-and-network'},
  );

  return <GeneralAssetModelsTable generalAssetModels={data} />;
}

export default withSuspense(ListPage);

const generalAssetModels = graphql`
  query listPagegeneralAssetModelsQuery($first: Int!) {
    ...GeneralAssetModelsTable_generalAssetModels @arguments(first: $first)
  }
`;
